/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'test': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M85 91.301l-10.199-13.5c-2.3-3-3.602-6.8-3.602-10.602V50.101c4.899-5.602 7.602-13.102 7-21.301-1.101-14-12.5-25.301-26.5-26.398-16.398-1.3-30.102 11-31.199 26.898v.7c0 2.6-1 6.698-2.199 9-1.3 2.398-2.601 4.8-3.699 6.5-1.102 1.698.102 3.898 2.102 3.898h3.8v13.898c0 2.8 2.301 5.101 5.102 5.101h10.5v5.301c0 3.602-1.398 7.102-4 9.602l-8 8.101c-2.3 2.399-.7 6.399 2.602 6.399H81.81C85.103 97.698 87 93.897 85 91.3zM61.699 19L49.398 31.301l12.301 12.301c-6.8 6.8-17.801 6.8-24.602 0l12.301-12.301L37 19c6.8-6.8 17.898-6.8 24.699 0z"/>'
  }
})
